import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=370bb547"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports